import { IListItemModel } from "./listItemModel";

export class AvailabilityTimeRange {
    public userHoursOfOperationId: number = 0;
    public userWorkLocation: number | null = null;
    public startTime: Date = new Date();
    public endTime: Date = new Date();
    public eligibleForInPersonAppointments: boolean = false;
    public eligibleForPhoneAppointments: boolean = false;
    public eligibleForVirtualAppointments: boolean = false;
    public selectedMeetingPreference: Array<IListItemModel> = [];

    public isStartTimeValid: boolean = true;
    public isEndTimeValid: boolean = true;
    public isPreviousInputStartTime: boolean = false;
    public isStartTimeOverlapped: boolean = false;
    public isEndTimeOverlapped: boolean = false;
}